import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BASE_URL = "https://www.nextwave-marine.com";

const seoData = {
  '/': {
    es: {
      title: "NextWave Marine | Seakeeper, Dockmate & Opacmare - Mallorca",
      description: "Distribuidor autorizado de Seakeeper, Dockmate y Opacmare en Baleares y Espana. Estabilizadores giroscopicos, control remoto de maniobras y equipamiento nautico premium. +35 anos de experiencia en el sector nautico.",
      keywords: "Seakeeper Espana, Dockmate Espana, Opacmare, estabilizador giroscopico barco, nautica Mallorca, equipamiento marino premium, servicio tecnico nautico Baleares, mando inalambrico barco"
    },
    en: {
      title: "NextWave Marine | Seakeeper, Dockmate & Opacmare - Mallorca, Spain",
      description: "Authorized dealer of Seakeeper, Dockmate and Opacmare in the Balearic Islands, Spain. Gyroscopic stabilizers, wireless docking systems and premium marine equipment. Over 35 years of marine expertise.",
      keywords: "Seakeeper Spain, Dockmate dealer, Opacmare, gyroscopic stabilizer yacht, marine equipment Mallorca, boat stabilizer, wireless docking system, yacht services Balearics"
    },
    de: {
      title: "NextWave Marine | Seakeeper, Dockmate & Opacmare - Mallorca, Spanien",
      description: "Autorisierter Handler von Seakeeper, Dockmate und Opacmare auf den Balearen, Spanien. Kreiselstabilisatoren, kabellose Manoversteuerung und Premium-Yachtausrustung. Uber 35 Jahre Erfahrung im Yachtsektor.",
      keywords: "Seakeeper Spanien, Dockmate Handler, Opacmare, Kreiselstabilisator Yacht, Yachtausrustung Mallorca, Bootsstabilisator, kabellose Manoversteuerung, Yachtservice Balearen"
    },
    it: {
      title: "NextWave Marine | Seakeeper, Dockmate & Opacmare - Maiorca, Spagna",
      description: "Distributore autorizzato di Seakeeper, Dockmate e Opacmare nelle Isole Baleari, Spagna. Stabilizzatori giroscopici, telecomando per manovre e attrezzature nautiche premium. Oltre 35 anni di esperienza nel settore nautico.",
      keywords: "Seakeeper Spagna, Dockmate distributore, Opacmare, stabilizzatore giroscopico barca, attrezzature nautiche Maiorca, manovre porto wireless, servizi nautici Baleari"
    }
  },
  '/seakeeper': {
    es: {
      title: "Seakeeper - Estabilizador Giroscopico para Barcos | NextWave Marine",
      description: "Instalacion profesional de estabilizadores giroscopicos Seakeeper en Mallorca. Elimina el balanceo de tu embarcacion, navega sin mareos y disfruta del fondeo en cualquier condicion. Solicita tu prueba de mar.",
      keywords: "Seakeeper, estabilizador giroscopico, anti balanceo barco, mareo barco solucion, Seakeeper Mallorca, Seakeeper Espana, estabilizador yate, Seakeeper instalacion, prueba de mar Seakeeper"
    },
    en: {
      title: "Seakeeper - Gyroscopic Stabilizer for Boats | NextWave Marine",
      description: "Professional Seakeeper gyroscopic stabilizer installation in Mallorca. Eliminate boat roll, enjoy seasickness-free cruising and anchor anywhere in any condition. Request your sea trial today.",
      keywords: "Seakeeper, gyroscopic stabilizer, anti-roll boat, seasickness solution, Seakeeper Mallorca, Seakeeper Spain, yacht stabilizer, Seakeeper installation, sea trial Seakeeper"
    },
    de: {
      title: "Seakeeper - Kreiselstabilisator fur Yachten | NextWave Marine",
      description: "Professionelle Installation von Seakeeper Kreiselstabilisatoren auf Mallorca. Beseitigen Sie das Schaukeln Ihrer Yacht, geniessen Sie seekrankheitsfreies Segeln und ankern Sie uberall. Probefahrt anfragen.",
      keywords: "Seakeeper, Kreiselstabilisator, Anti-Roll Yacht, Seekrankheit Losung, Seakeeper Mallorca, Seakeeper Spanien, Yachtstabilisator, Seakeeper Installation, Probefahrt"
    },
    it: {
      title: "Seakeeper - Stabilizzatore Giroscopico per Barche | NextWave Marine",
      description: "Installazione professionale di stabilizzatori giroscopici Seakeeper a Maiorca. Elimina il rollio della tua imbarcazione, naviga senza mal di mare e ancora ovunque. Richiedi la tua prova in mare.",
      keywords: "Seakeeper, stabilizzatore giroscopico, anti rollio barca, mal di mare soluzione, Seakeeper Maiorca, Seakeeper Spagna, stabilizzatore yacht, prova in mare Seakeeper"
    }
  },
  '/dockmate': {
    es: {
      title: "Dockmate - Control Remoto Inalambrico para Barcos | NextWave Marine",
      description: "Instalacion de Dockmate en Mallorca: maniobra tu barco sin estres con el mando inalambrico. Atraca y desatraca desde cualquier punto de la embarcacion con total precision y seguridad.",
      keywords: "Dockmate, mando inalambrico barco, control remoto maniobras, atracar barco facil, Dockmate Espana, Dockmate Mallorca, maniobras puerto sin estres, sistema atraque inalambrico"
    },
    en: {
      title: "Dockmate - Wireless Remote Docking System | NextWave Marine",
      description: "Dockmate installation in Mallorca: maneuver your boat stress-free with the wireless remote. Dock and undock from any point on the vessel with total precision and safety.",
      keywords: "Dockmate, wireless boat control, remote docking system, easy boat docking, Dockmate Spain, Dockmate Mallorca, stress-free docking, wireless maneuvering system"
    },
    de: {
      title: "Dockmate - Kabellose Fernsteuerung fur Boote | NextWave Marine",
      description: "Dockmate Installation auf Mallorca: Manovrieren Sie Ihr Boot stressfrei mit der kabellosen Fernbedienung. An- und Ablegen von jedem Punkt des Bootes mit voller Prazision und Sicherheit.",
      keywords: "Dockmate, kabellose Bootsteuerung, Fernsteuerung Manovrieren, einfaches Anlegen Boot, Dockmate Spanien, Dockmate Mallorca, stressfreies Anlegen, kabelloses Manovriersystem"
    },
    it: {
      title: "Dockmate - Telecomando Wireless per Barche | NextWave Marine",
      description: "Installazione Dockmate a Maiorca: manovra la tua barca senza stress con il telecomando wireless. Ormeggia e disormeggia da qualsiasi punto dell'imbarcazione con totale precisione.",
      keywords: "Dockmate, telecomando wireless barca, controllo remoto manovre, ormeggio facile, Dockmate Spagna, Dockmate Maiorca, manovre porto senza stress, sistema ormeggio wireless"
    }
  },
  '/equipo': {
    es: {
      title: "Nuestro Equipo - Expertos en Nautica | NextWave Marine",
      description: "Conoce al equipo de NextWave Marine: Jaime Capell (Ventas y Proyectos), Miriam Cirella (Operaciones) y Markus Ruesseler (Responsable Tecnico, Seakeeper Master). Profesionales con decadas de experiencia nautica.",
      keywords: "equipo NextWave Marine, Jaime Capell, Miriam Cirella, Markus Ruesseler, Seakeeper Master, tecnicos nauticos Mallorca, expertos nautica Baleares"
    },
    en: {
      title: "Our Team - Marine Experts | NextWave Marine",
      description: "Meet the NextWave Marine team: Jaime Capell (Sales & Projects), Miriam Cirella (Operations) and Markus Ruesseler (Technical Manager, Seakeeper Master). Professionals with decades of marine expertise.",
      keywords: "NextWave Marine team, Jaime Capell, Miriam Cirella, Markus Ruesseler, Seakeeper Master, marine technicians Mallorca, nautical experts Balearics"
    },
    de: {
      title: "Unser Team - Yachtexperten | NextWave Marine",
      description: "Lernen Sie das Team von NextWave Marine kennen: Jaime Capell (Vertrieb & Projekte), Miriam Cirella (Betrieb) und Markus Ruesseler (Technischer Leiter, Seakeeper Master). Fachleute mit jahrzehntelanger Erfahrung.",
      keywords: "NextWave Marine Team, Jaime Capell, Miriam Cirella, Markus Ruesseler, Seakeeper Master, Yachttechniker Mallorca, Nautikexperten Balearen"
    },
    it: {
      title: "Il Nostro Team - Esperti Nautici | NextWave Marine",
      description: "Scopri il team di NextWave Marine: Jaime Capell (Vendite e Progetti), Miriam Cirella (Operazioni) e Markus Ruesseler (Responsabile Tecnico, Seakeeper Master). Professionisti con decenni di esperienza.",
      keywords: "team NextWave Marine, Jaime Capell, Miriam Cirella, Markus Ruesseler, Seakeeper Master, tecnici nautici Maiorca, esperti nautica Baleari"
    }
  },
  '/trabajos': {
    es: {
      title: "Proyectos e Instalaciones Nauticas | NextWave Marine",
      description: "Galeria de proyectos realizados por NextWave Marine: instalaciones de Seakeeper, Dockmate y equipamiento nautico en todo tipo de embarcaciones en Mallorca y Baleares.",
      keywords: "proyectos nauticos, instalaciones Seakeeper, instalaciones Dockmate, trabajos nauticos Mallorca, galeria proyectos marinos, embarcaciones equipadas"
    },
    en: {
      title: "Marine Projects & Installations | NextWave Marine",
      description: "Project gallery by NextWave Marine: Seakeeper, Dockmate and marine equipment installations across all types of vessels in Mallorca and the Balearic Islands.",
      keywords: "marine projects, Seakeeper installations, Dockmate installations, nautical works Mallorca, marine project gallery, equipped vessels"
    },
    de: {
      title: "Yachtprojekte & Installationen | NextWave Marine",
      description: "Projektgalerie von NextWave Marine: Seakeeper-, Dockmate- und Yachtausrustungsinstallationen auf allen Arten von Yachten auf Mallorca und den Balearen.",
      keywords: "Yachtprojekte, Seakeeper Installationen, Dockmate Installationen, Nautikarbeiten Mallorca, Marine-Projektgalerie, ausgerustete Yachten"
    },
    it: {
      title: "Progetti e Installazioni Nautiche | NextWave Marine",
      description: "Galleria progetti di NextWave Marine: installazioni Seakeeper, Dockmate e attrezzature nautiche su ogni tipo di imbarcazione a Maiorca e Baleari.",
      keywords: "progetti nautici, installazioni Seakeeper, installazioni Dockmate, lavori nautici Maiorca, galleria progetti marini, imbarcazioni attrezzate"
    }
  },
  '/otros-servicios': {
    es: {
      title: "Otros Servicios Nauticos | NextWave Marine",
      description: "Descubre todos los servicios nauticos de NextWave Marine: venta de embarcaciones, ingenieria naval, electronica de navegacion, equipos de seguridad y servicios de invernaje en Mallorca.",
      keywords: "servicios nauticos Mallorca, venta barcos, ingenieria naval, electronica navegacion, equipos seguridad maritima, invernaje embarcaciones"
    },
    en: {
      title: "Other Marine Services | NextWave Marine",
      description: "Discover all marine services by NextWave Marine: vessel sales, marine engineering, navigation electronics, safety equipment and winterization services in Mallorca.",
      keywords: "marine services Mallorca, boat sales, marine engineering, navigation electronics, maritime safety equipment, boat winterization"
    },
    de: {
      title: "Weitere Yachtservices | NextWave Marine",
      description: "Entdecken Sie alle Yachtservices von NextWave Marine: Yachtverkauf, Yachttechnik, Navigationselektronik, Sicherheitsausrustung und Winterlager auf Mallorca.",
      keywords: "Yachtservices Mallorca, Bootverkauf, Yachttechnik, Navigationselektronik, maritime Sicherheitsausrustung, Winterlager Boot"
    },
    it: {
      title: "Altri Servizi Nautici | NextWave Marine",
      description: "Scopri tutti i servizi nautici di NextWave Marine: vendita imbarcazioni, ingegneria navale, elettronica di navigazione, equipaggiamento di sicurezza e rimessaggio a Maiorca.",
      keywords: "servizi nautici Maiorca, vendita barche, ingegneria navale, elettronica navigazione, equipaggiamento sicurezza marittima, rimessaggio invernale"
    }
  },
  '/prueba-de-mar': {
    es: {
      title: "Prueba de Mar - Experimenta Seakeeper y Dockmate | NextWave Marine",
      description: "Solicita tu prueba de mar gratuita en Mallorca. Experimenta Seakeeper y Dockmate en nuestro barco demo antes de decidir. Siente la diferencia de navegar con estabilizador giroscopico.",
      keywords: "prueba de mar Seakeeper, demo Dockmate, prueba gratuita barco, experiencia Seakeeper, sea trial Mallorca, barco demo NextWave"
    },
    en: {
      title: "Sea Trial - Experience Seakeeper & Dockmate | NextWave Marine",
      description: "Request your free sea trial in Mallorca. Experience Seakeeper and Dockmate on our demo vessel before you decide. Feel the difference of sailing with a gyroscopic stabilizer.",
      keywords: "Seakeeper sea trial, Dockmate demo, free boat trial, Seakeeper experience, sea trial Mallorca, NextWave demo vessel"
    },
    de: {
      title: "Probefahrt - Erleben Sie Seakeeper & Dockmate | NextWave Marine",
      description: "Fordern Sie Ihre kostenlose Probefahrt auf Mallorca an. Erleben Sie Seakeeper und Dockmate auf unserem Demoboot, bevor Sie sich entscheiden. Spuren Sie den Unterschied.",
      keywords: "Seakeeper Probefahrt, Dockmate Demo, kostenlose Bootprobefahrt, Seakeeper Erlebnis, Probefahrt Mallorca, NextWave Demoboot"
    },
    it: {
      title: "Prova in Mare - Prova Seakeeper e Dockmate | NextWave Marine",
      description: "Richiedi la tua prova in mare gratuita a Maiorca. Prova Seakeeper e Dockmate sulla nostra barca demo prima di decidere. Senti la differenza di navigare con stabilizzatore giroscopico.",
      keywords: "prova in mare Seakeeper, demo Dockmate, prova gratuita barca, esperienza Seakeeper, prova in mare Maiorca, barca demo NextWave"
    }
  }
};

const localeMap = {
  es: 'es_ES',
  en: 'en_GB',
  de: 'de_DE',
  it: 'it_IT'
};

const langNames = {
  es: 'Spanish',
  en: 'English',
  de: 'German',
  it: 'Italian'
};

export const SEOHead = ({ language = 'es' }) => {
  const location = useLocation();
  const path = location.pathname;
  
  const pageData = seoData[path];
  if (!pageData) return null;
  
  const langData = pageData[language] || pageData['es'];
  const canonicalUrl = `${BASE_URL}${path === '/' ? '' : path}`;
  const languages = ['es', 'en', 'de', 'it'];
  
  // BreadcrumbList structured data
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "NextWave Marine",
        "item": BASE_URL
      }
    ]
  };
  
  if (path !== '/') {
    const pageName = langData.title.split('|')[0].split('-')[0].trim();
    breadcrumbData.itemListElement.push({
      "@type": "ListItem",
      "position": 2,
      "name": pageName,
      "item": `${BASE_URL}${path}`
    });
  }

  return (
    <Helmet>
      <html lang={language} />
      <title>{langData.title}</title>
      <meta name="description" content={langData.description} />
      <meta name="keywords" content={langData.keywords} />
      <meta name="language" content={langNames[language]} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Hreflang */}
      {languages.map(lang => (
        <link key={lang} rel="alternate" hreflang={lang} href={`${canonicalUrl}?lang=${lang}`} />
      ))}
      <link rel="alternate" hreflang="x-default" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={langData.title} />
      <meta property="og:description" content={langData.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={localeMap[language]} />
      <meta property="og:site_name" content="NextWave Marine" />
      <meta property="og:image" content="https://customer-assets.emergentagent.com/job_netx-launch/artifacts/uwz2cpai_Next_Wave_Marine_con%20blanco_logo_final.png" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={langData.title} />
      <meta name="twitter:description" content={langData.description} />
      <meta name="twitter:image" content="https://customer-assets.emergentagent.com/job_netx-launch/artifacts/uwz2cpai_Next_Wave_Marine_con%20blanco_logo_final.png" />
      
      {/* Structured Data: BreadcrumbList */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
